import React, { useEffect, useState } from "react";
import { PostData, updateDataByID } from "../../Utils/firebaseServices";
import "../../Assets/css/LibrarySidebarStyles.css";
import { Link } from "react-router-dom";
import {
  Button,
  Stack,
  Switch,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useColors } from "../../Assets/Theme/ThemeColors";
import AddDetailsInSubCategory from "./SidebarDataConnection/AddDetailsInSubCategory";
import LoadingCircular from "../../loader/LoadingCircular";
import DeleteSubCategory from "./SidebarDataConnection/DeleteSubCategory";
import { DeleteRounded } from "@mui/icons-material";
import DeleteAllComponent from "./SidebarDataConnection/DeleteAllComponent";

import { useNavigate } from "react-router-dom";
const LibrarySidebarComponent = ({ data, call_back_for_refresh }) => {
  const [switchStates, setSwitchStates] = useState(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isConditionPopupOpen, setIsConditionPopupOpen] = useState(false);
  const [isAvailablePopupOpen, setIsAvailablePopupOpen] = useState(false);

  const [desissionPopUp, setDesissionPopUp] = useState({ isShow: false });

  const [sidebarData, setSidebarData] = useState(data || []);
  const [additionalFields, setAdditionalFields] = useState([]);

  const [popupType, setPopUpType] = useState("add");
  const [newCategoryTitle, setNewCategoryTitle] = useState("");
  const [addfeildCategory, setAAddfeildCategory] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({ title: "", additionalFields: [] });
  const [loading, setLoading] = useState(true);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeleteAllDialogOpen, setIsDeleteAllDialogOpen] = useState(false);
  const [isDeleteItemDialogOpen, setIsDeleteItemDialogOpen] = useState(false);
  const { Colors } = useColors();
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    setSidebarData(data);
  }, [data]);

  useEffect(() => {
    setSidebarData(data);
    setLoading(false);
  }, [data]);
  const handleClick = ({ key, value, index, item, event }) => {
    switch (key) {
      case "add_new_category":
        setNewCategoryTitle("");
        setAdditionalFields([]);
        setPopUpType("add");
        setIsDialogOpen(true);
        break;

      case "close_add_new_category_modal":
        handleCloseModal();
        break;

      case "remove_addition_input_from_modal":
        const updatedFields = additionalFields.filter((_, i) => i !== value);
        setAdditionalFields(updatedFields);
        break;

      case "add_additional_input_in_modal":
        setAdditionalFields([...additionalFields, ""]);
        break;

      case "add_new_sub_cat":
        addSubCategoryEditCategory(value, "add_new_sub_cat");
        break;

      case "edit_category":
        addSubCategoryEditCategory(value, "edit_category");
        break;

      case "active_inactive_category":
        if (
          value?.isDetailAvailable &&
          getDetailValue(value.items, "isActive")
        ) {
          setDesissionPopUp({
            isShow: true,
            title: "Warning",
            desc: "Do you want to active this category?",
            parentData: {
              key,
              value,
              index,
              event,
            },
          });
        } else {
          setDesissionPopUp({
            isShow: true,
            type: "error",
            title: "Error",
            desc: "Please add detail in any sub category before active category!",
            parentData: {
              key,
              value,
              index,
              event,
            },
          });
        }
        break;

      case "active_inactive_sub_category":
        if (item?.isDetailAvailable) {
          setDesissionPopUp({
            isShow: true,
            title: "Warning",
            desc: "Do you want to active this Sub category?",
            parentData: {
              key,
              value,
              index,
              event,
            },
          });
        } else {
          setDesissionPopUp({
            isShow: true,
            type: "error",
            title: "Error",
            desc: "Please add detail in this sub category!",
            parentData: {
              key,
              value,
              index,
              event,
            },
          });
        }
        break;

      case "add_and_edit_category_to_firebase":
        if (validateFields()) {
          handleSubmitDataToFirebase();
        }

      case "modal_close":
        setDesissionPopUp({ isShow: false });
        break;

      case "modal_action":
        if (value?.key === "active_inactive_category") {
          handleSwitchChange({
            key: value?.key,
            value: value?.value,
            event: value?.event,
          });
        } else {
          handleSwitchChange({
            key: value?.key,
            value: value?.value,
            index: value?.index,
            event: value?.event,
          });
        }
        setDesissionPopUp({ isShow: false });
        break;

      default:
        break;
    }
  };

  const handleAdditionalFieldChange = (index, value) => {
    let data_obj = {
      index: index,
      title: value,
      l_s_c_d_id: [],
      isActive: false,
      isDetailAvailable: false,
    };

    const updatedFields = additionalFields.map((item, i) =>
      i === index ? data_obj : item
    );
    setAdditionalFields(updatedFields);
  };

  const handleSwitchChange = async ({ key, value, index, event }) => {
    let data_obj = {
      isActive: value?.isActive,
      isDetailAvailable: value?.isDetailAvailable,
      title: value.title,
      items: value.items,
    };

    if (key === "active_inactive_category") {
      const res = await updateDataByID(
        value?.id,
        { ...data_obj, isActive: !data_obj.isActive },
        "library_sidebar_categories_collection",
        refreshCategory
      );
    }

    if (key === "active_inactive_sub_category") {
      let isForActive = false;
      let new_data_obj = {
        ...data_obj,
        items: getItems(
          data_obj.items.map((item, ind) => {
            if (ind === index) {
              if (!getParseData(item).isActive) {
                isForActive = true;
              }
              return {
                ...getParseData(item),
                isActive: !getParseData(item).isActive,
              };
            } else {
              return {
                ...getParseData(item),
              };
            }
          })
        ),
      };
      const res = await updateDataByID(
        value?.id,
        {
          ...new_data_obj,
          isDetailAvailable: getDetailValue(
            new_data_obj.items,
            "isDetailAvailable"
          ),
          isActive: isForActive
            ? new_data_obj?.isActive
            : getDetailValue(new_data_obj.items, "isActive"),
        },
        "library_sidebar_categories_collection",
        refreshCategory
      );
    }
  };

  const getDetailValue = (array, key) => {
    let isAvailable = false;
    for (let item of array) {
      if (getParseData(item)[key]) {
        isAvailable = true;
      }
    }
    return isAvailable;
  };

  const refreshCategory = () => {
    call_back_for_refresh && call_back_for_refresh();
    setLoading(false);
  };

  const handleCloseModal = () => {
    setIsDialogOpen(false);
    setNewCategoryTitle("");
    setAAddfeildCategory(null);
    setErrors({ title: "", additionalFields: [] });
  };

  const addSubCategoryEditCategory = (category, type) => {
    setPopUpType(type);
    setAAddfeildCategory(category);
    setAdditionalFields(category.items.map((item) => getParseData(item)));
    setNewCategoryTitle(category.title);
    setIsDialogOpen(true);
  };

  const handleSubmitDataToFirebase = async () => {
    let library_sidebar_data = {
      isActive: addfeildCategory?.isActive || false,
      isDetailAvailable: addfeildCategory?.isDetailAvailable || false,
      items: getItems(additionalFields),
      title: newCategoryTitle,
    };

    console.log(" >> . > . > ", library_sidebar_data);

    if (popupType === "add") {
      const res = await PostData(
        library_sidebar_data,
        "library_sidebar_categories_collection",
        refreshCategory
      );
    } else {
      const res = await updateDataByID(
        addfeildCategory?.id,
        library_sidebar_data,
        "library_sidebar_categories_collection",
        refreshCategory
      );
    }

    handleCloseModal();
  };

  const handleAvailablePopupClose = () => {
    setIsAvailablePopupOpen(false);
    handleSwitchChange({
      key: "active_inactive_category",
      value: currentCategory,
    });
  };

  const getItems = (array) => {
    let new_array = [];
    for (let item of array) {
      new_array.push(getJSONData(item));
    }
    return new_array;
  };

  const getJSONData = (item) => {
    if (item) {
      return JSON.stringify(item);
    } else {
      return "";
    }
  };
  const handleOpenDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const getParseData = (item) => {
    if (item) {
      return JSON.parse(item);
    } else {
      return "";
    }
  };
  const handleOpenDetailsModal = ({ category, index }) => {
    setIsModalOpen({ category: category, index: index });
  };

  const handleCloseDetailsModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseDeleteDialog = () => {
    console.log("Closing delete modal");
    setIsDeleteItemDialogOpen(false);
  };

  const handleOpenDeleteItemModal = ({ category, indx }) => {
    setIsDeleteItemDialogOpen({ category: category, index: indx });
  };

  const handleOpenDeleteModal = ({ category, index, item }) => {
    setIsDeleteDialogOpen({ category: category, index: index, item: item });
  };

  // const handleDeleteSuccess = (deletedCategoryId) => {

  //   setCategories(prevCategories =>
  //     prevCategories.filter(category => category.id !== deletedCategoryId)
  //   );
  // };

  const handleViewDetails = (category, indx) => {
    navigate("/admin/ViewDetails", { state: { category, indx } });
  };

  const renderCategoryList = () => {
    return sidebarData?.map((category, indx) => {
      return (
        <Accordion
          key={indx}
          sx={{
            boxShadow: "none !important",
            padding: "0px !important",
            marginBlock: "5px !important",
            width: "70%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: category?.isDetailAvailable
                ? " 1px solid black"
                : " 1px solid red",
              borderRadius: "5px",
              padding: "5px",
              paddingLeft: "10px",
              marginTop: 20,
              marginBottom: 5,
            }}
          >
            <AccordionSummary
              id="panel-header"
              aria-controls="panel-content"
              sx={{
                margin: "0px !important",
                padding: "0px !important",
                minHeight: "0px !important",
                justifyContent: "space-between",
                color: "#000",
                fontWeight: "bold",
                "& .MuiAccordionSummary-content": {
                  margin: "0px !important",
                  padding: "0px !important",
                },
                gap: 10,
                fontSize: "16px",
                flexGrow: 1,
              }}
            >
              {category?.title}
            </AccordionSummary>
            <>
              <div>
                <Switch
                  checked={category?.isActive || false}
                  onChange={(e) => {
                    handleClick({
                      key: "active_inactive_category",
                      value: category,
                      event: e,
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
              <Box className="buttonconatainer">
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    sx={{
                      backgroundColor: "black",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "black",
                      },
                    }}
                    onClick={() => handleViewDetails(category)}
                  >
                    viewdetails
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    sx={{
                      backgroundColor: "black",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "black",
                      },
                    }}
                    onClick={() => {
                      handleClick({
                        key: "edit_category",
                        value: category,
                      });
                    }}
                  >
                    Edit
                  </Button>

                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{
                      backgroundColor: "black",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "black",
                      },
                    }}
                    onClick={() => {
                      handleClick({
                        key: "add_new_sub_cat",
                        value: category,
                      });
                    }}
                  >
                    Add
                  </Button>

                  <Button
                    variant="contained"
                    startIcon={<DeleteRounded />}
                    sx={{
                      backgroundColor: "black",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: "black",
                      },
                    }}
                    onClick={() =>
                      handleOpenDeleteItemModal({ category, indx })
                    }
                  >
                    Delete
                  </Button>

                  {isDeleteItemDialogOpen && (
                    <DeleteAllComponent
                      open={isDeleteItemDialogOpen ? true : false}
                      onClose={handleCloseDeleteDialog}
                      componentData={isDeleteItemDialogOpen}
                      // onDeleteSuccess={handleDeleteSuccess}
                    />
                  )}
                </Stack>
              </Box>
            </>
          </div>
          <>
            {category?.items?.length > 0 &&
              category?.items.map((item, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderTop: "none",
                      borderRight: "1px solid black",
                      borderBottom: getParseData(item)?.isDetailAvailable
                        ? "1px solid black"
                        : "1px solid red",
                      borderLeft: "1px solid black",
                      padding: "5px",
                      paddingLeft: "10px",
                      marginBottom: 5,
                      marginLeft: "2%",
                      background: "#dce0df",
                      alignItems: "start",
                    }}
                  >
                    <AccordionDetails
                      key={index}
                      sx={{
                        padding: "10px",
                        flexGrow: 1,
                        marginLeft: "5%",
                      }}
                    >
                      {getParseData(item)?.title}
                    </AccordionDetails>
                    <div>
                      <Switch
                        checked={getParseData(item)?.isActive || false}
                        onChange={(e) => {
                          handleClick({
                            key: "active_inactive_sub_category",
                            value: category,
                            index: index,
                            item: getParseData(item),
                            event: e,
                          });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#000",
                          },
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 10,
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        sx={{
                          backgroundColor: "black",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "black",
                          },
                        }}
                        onClick={() =>
                          handleOpenDetailsModal({ category, index })
                        }
                      >
                        Add Details
                      </Button>
                      {isModalOpen && (
                        <AddDetailsInSubCategory
                          open={isModalOpen ? true : false}
                          onClose={handleCloseDetailsModal}
                          componentData={isModalOpen}
                        />
                      )}

                      <Button
                        variant="contained"
                        startIcon={<DeleteRounded />}
                        sx={{
                          backgroundColor: "black",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "black",
                          },
                        }}
                        onClick={() =>
                          handleOpenDeleteModal({ category, index })
                        }
                      >
                        Delete
                      </Button>

                      {isDeleteDialogOpen && (
                        <DeleteSubCategory
                          open={isDeleteDialogOpen ? true : false}
                          onClose={handleCloseDialog}
                          componentData={isDeleteDialogOpen}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
          </>
        </Accordion>
      );
    });
  };

  const renderModal = ({ title, isShow, desc, type, parentData }) => {
    return (
      <Dialog open={isShow} onClose={() => {}}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <p>{desc}</p>
        </DialogContent>
        <DialogActions>
          {type === "error" ? (
            <Button onClick={() => handleClick({ key: "modal_close" })}>
              Cancal
            </Button>
          ) : (
            <>
              <Button onClick={() => handleClick({ key: "modal_close" })}>
                No
              </Button>
              <Button
                onClick={() =>
                  handleClick({ key: "modal_action", value: parentData })
                }
              >
                Yes
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const validateFields = () => {
    let isValid = true;
    const newErrors = { title: "", additionalFields: [] };

    if (newCategoryTitle.trim() === "") {
      newErrors.title = "Category Title is required";
      isValid = false;
    } else {
      newErrors.title = "";
    }

    additionalFields.forEach((field, index) => {
      if (!newErrors.additionalFields[index]) {
        newErrors.additionalFields[index] = "";
      }

      if (!field || field.title.trim() === "") {
        newErrors.additionalFields[index] = "This field cannot be empty";
        isValid = false;
      } else {
        newErrors.additionalFields[index] = "";
      }
    });

    while (newErrors.additionalFields.length < additionalFields.length) {
      newErrors.additionalFields.push("");
    }

    setErrors(newErrors);
    return isValid;
  };

  return (
    <>
      {loading ? (
        <LoadingCircular />
      ) : (
        <div className="library-sidebar">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 40,
              paddingBottom: 0,
            }}
          >
            <h2 className="title">Library </h2>
            <Button
              variant="contained"
              sx={{
                backgroundImage:
                  "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(67,67,71,1) 100%)",

                borderRadius: "5px",
                "&:hover": { backgroundColor: "#0056b3" },
                color: "black",
                fontWeight: "bold",
              }}
              onClick={() => {
                handleClick({ key: "add_new_category" });
              }}
            >
              <span style={{ color: "#fff" }}> Add New </span>
            </Button>
          </div>

          <div className="input-container">{renderCategoryList()}</div>
          <Dialog
            open={isDialogOpen}
            onClose={() => {
              handleClick({
                key: "close_add_new_category_modal",
              });
            }}
            sx={{
              "& .MuiDialog-container": {
                alignItems: "flex-start",
              },
              "& .MuiPaper-root": {
                width: "600px",
                maxWidth: "none",
              },
            }}
          >
            <DialogTitle>Add New Category</DialogTitle>

            <DialogContent>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Category Title"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={newCategoryTitle}
                    error={!!errors.title}
                    helperText={errors.title}
                    onChange={(e) => setNewCategoryTitle(e.target.value)}
                  />
                  {popupType !== "edit_category" && (
                    <Button
                      onClick={() => {
                        handleClick({
                          key: "add_additional_input_in_modal",
                        });
                      }}
                    >
                      Add Sub
                    </Button>
                  )}
                </div>
                {additionalFields.map((item, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <TextField
                      margin="dense"
                      label={`Additional Field ${index + 1}`}
                      type="text"
                      fullWidth
                      variant="standard"
                      value={item.title}
                      onChange={(e) =>
                        handleAdditionalFieldChange(index, e.target.value)
                      }
                      error={!!errors.additionalFields[index]}
                      helperText={errors.additionalFields[index]}
                    />
                    <IconButton
                      onClick={() => {
                        handleClick({
                          key: "remove_addition_input_from_modal",
                          value: index,
                        });
                      }}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </div>
                ))}
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleClick({
                        key: "close_add_new_category_modal",
                      });
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      handleClick({
                        key: "add_and_edit_category_to_firebase",
                      });
                    }}
                  >
                    SAVE
                  </Button>
                </DialogActions>
              </div>
            </DialogContent>
          </Dialog>
          {renderModal(desissionPopUp)}
        </div>
      )}
    </>
  );
};

export default LibrarySidebarComponent;
